let config = {
  inputLabel: 'subline',
  key: 'headline',
  inputType: 'textfield',
};

export default config;
